export const AccuracyBreakdown = ({ breakdown, testId = "accuracy-breakdown" }) => {
  if (!breakdown) return null;
  const groups = [
    { key: "by_band", label: "By confidence band", fmt: (k) => `${k}%` },
    { key: "by_timeframe", label: "By timeframe", fmt: (k) => k },
    { key: "by_symbol", label: "By symbol", fmt: (k) => k },
  ];
  const any = groups.some((g) => breakdown[g.key]?.length);
  if (!any) return null;
  return (
    <div className="grid sm:grid-cols-3 gap-3 mt-4" data-testid={testId}>
      {groups.map((g) => (
        <div key={g.key} className="rounded-xl bg-white/5 border border-white/10 p-3" data-testid={`${testId}-${g.key}`}>
          <p className="text-[10px] uppercase tracking-wider text-slate-500 mb-2">{g.label}</p>
          {(breakdown[g.key] || []).length === 0 ? <p className="text-xs text-slate-500">No resolved signals yet</p> : (
            <ul className="space-y-1.5">
              {(breakdown[g.key] || []).slice(0, 6).map((row) => (
                <li key={row.key} className="text-xs">
                  <div className="flex justify-between font-mono-num"><span className="text-slate-300">{g.fmt(row.key)}</span><span><span className="text-emerald-400 font-semibold">{row.hit_rate}%</span> <span className="text-slate-500">· {row.total} · pred {row.avg_predicted}%</span></span></div>
                  <div className="h-1 rounded-full bg-white/5 mt-1 overflow-hidden"><div style={{ width: `${row.hit_rate}%` }} className="h-full bg-emerald-500" /></div>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};
